import { tryCheckPermForLinks } from '../actions/publicActions';
import { getAllRecipients } from '../utils/getAllRecipients';
import { shouldCheckPermForLink } from '../utils/shouldCheckPermForLink';
import { updateRecipientsOnLink } from '../utils/updateRecipientsOnLink';
import { RecipientMemberInfo } from 'owa-recipient-types/lib/types/RecipientMemberInfo';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';

orchestrator(tryCheckPermForLinks, async actionMessage => {
    if (!shouldCheckPermForLinks(actionMessage.linkIds)) {
        return;
    }

    trace.info('RecipientPermission: tryCheckPermForLinks');

    const allRecipients: RecipientMemberInfo[] = await getAllRecipients(
        actionMessage.linkIds,
        actionMessage.recipientInfos,
        actionMessage.composeId
    );

    for (let i: number = 0; i < actionMessage.linkIds.length; i++) {
        const linkId = actionMessage.linkIds[i];
        await updateRecipientsOnLink(linkId, allRecipients, actionMessage.composeId);
    }
});

export function shouldCheckPermForLinks(linkIds: string[]): boolean {
    return linkIds.some(function (linkId) {
        return shouldCheckPermForLink(linkId);
    });
}
